<script>
  import { useLocation, Link as NavLink } from "svelte-navigator";
  import { locale, locales, _ } from 'svelte-i18n'

  const location = useLocation();

  let germanPath, englishPath

  $: {
    germanPath = '/de' + $location.pathname
    englishPath = $location.pathname == "/de" ? "/" : $location.pathname.substring(3)
  }

  //  // reload now
  //
  //  <NavLink to={germanPath} >
  //    Deutsch
  //  </NavLink>
  //
  //  // reload later
  //
  //  <span on:click={ () => $locale = "de" }>
  //    Deutsch
  //  </span>

</script>

<ul>
  <li class:hidden={ $locale === "de"}>
    <NavLink to={germanPath} >
      <slot name="de" />
    </NavLink>
  </li>
  <li class:hidden={ $locale === "en"}>
    <NavLink to={englishPath} >
      <slot name="en" />
    </NavLink>
  </li>
</ul>

<style lang="scss">

  .hidden {
    display:none;
  }

</style>